import {Injectable} from "@angular/core";
import {ServerService} from "./ServerService";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class PedidosProduzirService  extends ServerService{
  constructor(http: HttpClient) {
    super(http);
  }


  listePedidosProduzir(areaSelecionada: any, filtro: any = {}){
    return this.obtenha(`/pedidos/produzir/${areaSelecionada.id}/pendentes`, filtro);
  }


  atualizePronto(pedidoProduzir: any){
    return this.facaPost(`/pedidos/produzir/${pedidoProduzir.id}/pronto`, pedidoProduzir);
  }

  listeProducoesDoPedido(idPedido: number) {
    return this.obtenha(`/pedidos/produzir/itens/pedido/${idPedido}`, {});
  }

  listeProducoesDaArea(idArea: number) {
    return this.obtenha(`/pedidos/produzir/itens/fila/${idArea}`, {});
  }

  opcoesProducao() {
    return this.obtenha('/pedidos/produzir/itens/opcoes', {});
  }

  salveProducao(id: number, dados: any) {
    return this.facaPost(`/pedidos/produzir/itens/${id}`, dados);
  }

  concluaProducao(id: number, dados: any) {
    return this.facaPost(`/pedidos/produzir/itens/${id}/concluir`, dados);
  }


}
